export default __webpack_public_path__ + "static/B0205-7417f47c61d3f4c03cb9ea8de88cd175.png";